<template>

    <div v-if="show">
    <not-allowed v-if="!AllowedDisplay"></not-allowed>

    <v-dialog v-model="dialogReccur" width="500" @click:outside="cancelReccur">
        <v-card>
            <v-card-title>
                Modifier l'évènement périodique
            </v-card-title>

            <v-card-text v-if="eventReccur">

      <v-radio-group
        v-model="choiceReccur"
        :mandatory="true"
      >
        <v-radio
          label="Cet événement seulement"
          value="single"
          class="mr-4"
        />
        <v-radio
          label="Cet événement et tous les suivants"
          value="future"
          class="mr-4"
        />
        <v-radio
        v-if="recurrForAll"
          label="Tous les événements"
          value="all"
        />
      </v-radio-group>
            </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="cancelReccur">Annuler</v-btn>
      <v-btn color="primary" @click="applyChangeReccur">Appliquer</v-btn>
    </v-card-actions>
        </v-card>
    </v-dialog>


    <div class="planning-container">

                    <v-row no-gutters v-if="listFiches.length && !isMobile">
                        <v-col class="elevation-1">
                            <v-tabs v-model="tabsFiches" class="blue" background-color="deep-purple lighten-4">

                                    <v-tab v-show="false"></v-tab>
                                    <v-tab v-for="(fiche,i) in listFiches" :key="'lf'+i"  
                                    :href="'#'+fiche.key" @click="callList(fiche,i)" 
                                    :data-key="fiche.key"
                                    style="border:2px solid;"
                                    :class="[dragging && fiche.isdroppable ? 'blue lighten-3 elevation-2' : 'grey lighten-3',' rounded ma-1 pa-3',fiche.isdroppable ? 'droppable-tab' : '']">
                                    <v-icon v-if="fiche.isdroppable && dragging">mdi-arrow-collapse-down</v-icon>
                                    {{ fiche.name }}</v-tab>

                                
                                <v-tabs-items v-model="tabsFiches" style="position:relative;">
                                    <v-tab-item></v-tab-item>
                                    <v-tab-item v-for="(fiche,i) in listFiches" :key="'lff'+i" :id="fiche.key">
                                        <v-progress-linear v-if="waitCallList"  color="blue" height="3" indeterminate></v-progress-linear>
                                        <SimpleTable
                                        v-if="fiche.list.length && !fiche.isdroppable"
                                        :Headers="fiche.headers"
                                        :datas="fiche.list"
                                        :editTable="[]"
                                        :hidefooter="false"
                                        @clickRow="putFicheForward"
                                    />

                                        <v-row no-gutters v-if="fiche.isdroppable">
                                            <div :style="{'background-color' : (list.ongletcolor) ? list.ongletcolor : '' }" 
                                            v-for="(list,f) in fiche.list" 
                                            :key="'fa'+f" 
                                            v-bind="generateDataAttributes(list)"
                                            :class="['pa-3 text-center ma-1 rounded elevation-1 text-caption', { iscoldraggable: !isMobile }]">{{ list.ongletname }}</div>
                                            <v-col v-if="!fiche.list.length && !waitCallList" style="text-align:center;"><b>Aucune fiche</b></v-col>
                                        </v-row>
   
                                    </v-tab-item>
                                </v-tabs-items>
                            </v-tabs>
                        </v-col>
                    </v-row>

                    <v-row no-gutters v-if="!isMobile">
                        <v-col  v-for="(fiche,i) in fichesForward" @click="selectFiche(fiche)" 
                            :key="'fiche-'+i" 
                            :class="['col-2 pa-1 text-center text-caption ml-1 text-wrap','rounded','ongletsforwards',ficheSelected===fiche ? 'elevation-2':'elevation-1']" 
                            :style="{'background-color':(fiche.ongletcolor)?fiche.ongletcolor:'#d3d3d3', 
                            'opacity' : ficheSelected===fiche ? '1':'0.7', 
                            'border' : ficheSelected===fiche ? '2px solid':'1px solid grey',
                            'cursor' : 'pointer'}">
                            {{ fiche.ongletname }}
                            <v-icon justify="end" @click="removeForward(fiche,i)">mdi-close</v-icon>
                        </v-col>
                    </v-row>

                    
                    <v-row no-gutters >
                        <v-col class="col-md-5 col-12 text-center text-md-left" v-if="!isMobile">
                            <v-btn-toggle
                            v-model="PlanningParams.displayAllDay"
                            mandatory
                            rounded
                            flat
                            >
                            <v-btn :value="0" small>Jour+horaire</v-btn>
                            <v-btn :value="1" small>Jour</v-btn>
                            <v-btn :value="2" small>Horaire</v-btn>
                            </v-btn-toggle>
                        </v-col>
                        <v-col class="col-md-2 col-12 text-center">
                            <v-btn small @click="prev"><v-icon>mdi-arrow-left</v-icon></v-btn>
                            <template v-if="$route.query.period!=0">
                                {{ moment($route.query.start).format('MMMM YYYY') }}
                            </template>
                            <template v-if="$route.query.period==0">
                                Semaine {{ moment($route.query.start).isoWeek() }}
                            </template>                           
                            <v-btn small @click="next"><v-icon>mdi-arrow-right</v-icon></v-btn>
                        </v-col>
                        <v-col class="col-md-5 col-12 text-center text-md-right">
                            <v-btn-toggle
                            v-model="selectedPeriod"
                            mandatory
                            rounded
                            flat
                            >
                            <v-btn value="0" small>Semaine</v-btn>
                            <v-btn value="1" small>1 Mois</v-btn>
                            <v-btn value="2" small>2 Mois</v-btn>
                            <v-btn value="3" small>3 Mois</v-btn>
                            </v-btn-toggle>
                        </v-col>
                    </v-row>

         <!--debut du tableau-->

        <table class="planning-table">
        <thead>
            <tr>
            <th :rowspan="3" colspan="2" v-if="!isMobile" class="personnel-header">
                <span class="d-none d-md-inline">Personnel</span>
                <span class="d-md-none">Type</span>
            </th>
            </tr>

            <tr>
                <th v-for="week in filteredWeeks" :key="'week-' + week.weekNumber" :colspan="week.visibleDays.length">S{{ week.weekNumber }}</th>
            </tr>
            <tr>
                <th v-for="day in visibleDays" :key="day.format('YYYY-MM-DD')"
                    :class="[{'weekend': isWeekend(day)},{'ferie': joursFerie[day.format('YYYY-MM-DD')]}]"
                    >{{ day.format('ddd') }}<br>{{ day.format('DD/MM') }}
                <div v-if="joursFerie[day.format('YYYY-MM-DD')]" style="font-size:9px;">{{ joursFerie[day.format('YYYY-MM-DD')] }}</div>
                </th>
            </tr>
        </thead>
        <tbody>
            <!-- Nom des groupes-->

            <template v-for="(group, i) in listGroup">
            <tr :key="'gr'+i" class="namegroup">
                <td :colspan="groupColSpan"> {{  group.name }}</td>
            </tr>

            <!-- début de boucle des lignes-->
            <template v-for="(pers, p) in group.list">
            <tr :key="'per-header-'+i+'-'+p" class="namepers d-md-none">
                <td :colspan="groupColSpan">{{ pers.name }}</td>
            </tr>
            <tr 
            v-if="PlanningParams.displayAllDay===0 || PlanningParams.displayAllDay===1"
            class="planning-list-items" 
            :key="'per'+i+p">
            <!-- Première cellule avec rowspan -->
            <td :rowspan="[(PlanningParams.displayAllDay===1)?'1':'2']" :class="['pl-design','d-none','d-md-table-cell']" @click="actLine(pers)">{{ pers.name }}</td>
            <td class="pl-design"  v-if="!isMobile">J</td>

            <!-- Boucle sur les events en mode journée -->
             <!-- :style="calculHeightTd(day, pers.id)" c'est ce que je mettais pour calculer la hauteur du td pour l'ajuster avec les div -->
            <td 
                v-for="day in visibleDays" 
                :key="'day1-'+day.format('YYYY-MM-DD')+'-'+pers.line" 
                :data-day="day.format('YYYY-MM-DD')" 
                :data-line="pers.line" 
                :data-allday="true" 
                data-typeelement="td"                
                :class="['droppable-td','allday','getwidth',{'weekend': isWeekend(day)},{'ferie': joursFerie[day.format('YYYY-MM-DD')]}]">
                

                    <!-- Contenu dynamique -->
                     <!-- :style="getDivStyle(event, day, pers.line,true)" c'est ce que je mettais pour mettre le div à la bonne hauteur en fonction des autres rdv-->
                    <div 
                    :class="['planning-divday-content', { isdivdraggable: !isMobile, isdivresizable: !isMobile }]" 
                    v-for="event in indexedEvents[day.format('YYYY-MM-DD')]?.[pers.line] || []" 
                    :key="'event1-'+event.id" 
                    :data-day="event.nbdays" 
                    data-typeelement="div" 
                    v-bind="generateDataAttributes(event)" 
                    @mouseenter="(!dragging) ? showTooltip($event, event):false"
                    @mouseleave="hideTooltip(event.id)"
                    @dblclick.stop.prevent="onDbl(event)"       
                    @touchend.passive="onTouchEnd(event)" 
                    @contextmenu.prevent="openContextMenu($event, event)"
                    :style="{width : `${defaultWidthTd*event.nbdays}px`,
                        height : `${PlanningParams.minHeightDivDay}px`,
                        backgroundColor : (event.fontcolor) ? event.fontcolor : '#FFFFFF',
                        borderColor : event.bordercolor,
                        fontSize : `${PlanningParams.fontSizeDiv}px`
                    }"
                    >
                        <div class="planning-dot-state" :style="'background-color:'+event.dotcolor+';'"></div>
                        <CPage 
                        v-if="selectedPeriod == 0"
                        :pageTemplate="displayEncart(event)" 
                        :customparams="event.otherfields"
                        :page="page" 
                        :modal="modal"
                        :modalKey="modalKey" 
                        :form="false" 
                        hook="hook"
                        :mod="false"/>
                        <div v-else v-html="event.strdisplay"></div>
                    </div>

            </td>
            </tr>

            <!-- debut de boucle pour les events en horaire -->
        <tr :key="'per-row2-'+i+p"
        v-if="PlanningParams.displayAllDay===0 || PlanningParams.displayAllDay===2"
        class="trhours"
        >
            <td
            v-if="PlanningParams.displayAllDay===2"
            :rowspan="[(PlanningParams.displayAllDay===2)?'1':'2']"
            :class="['pl-design','d-none','d-md-table-cell']"
            >{{ pers.name }}</td>
            <td class="pl-design"  v-if="!isMobile">H</td>
            <td 
                v-for="day in visibleDays" 
                :key="'day2-'+day.format('YYYY-MM-DD')+'-'+pers.line" 
                data-typeelement="td" 
                :class="['getwidth',{'weekend': isWeekend(day)},{'ferie': joursFerie[day.format('YYYY-MM-DD')]}]"
                >

                <div class="droppable-div am"
                :data-day="day.format('YYYY-MM-DD')"
                :data-line="pers.line"
                :data-allday="false"
                data-demi="am"
                >
                               

                <div class="planning-newhour" v-if="!isMobile" @click="createNewHourEvent(day,pers.line,'am')">+am</div>

                        <!-- liste des RDV du matin -->
                        <div 
                        :class="['planning-divhour-content', { isdivdraggable: !isMobile }]" 
                        v-for="event in indexedHalfDayEvents[day.format('YYYY-MM-DD')]?.[pers.line]?.['am'] || []" 
                        :key="'am-'+day.format('YYYY-MM-DD')+pers.line+event.id" 
                        :data-day="event.nbdays" 
                        data-typeelement="div" 
                        @dblclick="!isMobile && pinEvent(event)"
                        v-bind="generateDataAttributes(event)"
                        @dblclick.stop.prevent="onDbl(event)"       
                        @touchend.passive="onTouchEnd(event)" 
                        @mouseenter="(!dragging) ? showTooltip($event, event):false"
                        @mouseleave="hideTooltip(event.id)"
                        @contextmenu.prevent="openContextMenu($event, event)"
                        :style="{minHeight : (selectedPeriod == 0) ? `${4*PlanningParams.minHeightDivDay}px` : `${PlanningParams.minHeightDivDay}px`,
                            backgroundColor : (event.fontcolor) ? event.fontcolor : '#FFFFFF',
                            borderColor : event.bordercolor
                        }">
                        <div class="planning-dot-state" :style="'background-color:'+event.dotcolor+';'"></div>
                        <CPage 
                        v-if="selectedPeriod == 0"
                        :pageTemplate="displayEncart(event)" 
                        :customparams="event.otherfields"
                        :page="page" 
                        :modal="modal"
                        :modalKey="modalKey" 
                        :form="false" 
                        hook="hook"
                        :mod="false"/>
                        <div v-else v-html="event.strdisplay"></div>
                        </div>
                        <!-- FIN RDV matin -->
 
                </div>


                <hr class="hour-separator">


                <div class="droppable-div pm"
                :data-day="day.format('YYYY-MM-DD')"
                :data-line="pers.line"
                data-demi="pm"
                >

                        <!-- liste des RDV de l'apres midi-->
                        <div 
                        :class="['planning-divhour-content', { isdivdraggable: !isMobile }]" 
                        v-for="event in indexedHalfDayEvents[day.format('YYYY-MM-DD')]?.[pers.line]?.['pm'] || []" 
                        :key="'pm-'+day.format('YYYY-MM-DD')+pers.line+event.id"
                        :data-day="event.nbdays"
                        :ref="'pm-'+day.format('YYYY-MM-DD')+'-'+pers.line"
                        data-typeelement="div" 
                        @dblclick.stop.prevent="onDbl(event)"       
                        @touchend.passive="onTouchEnd(event)" 
                        @dblclick="!isMobile && pinEvent(event)"
                        v-bind="generateDataAttributes(event)"
                        @mouseenter="(!dragging) ? showTooltip($event, event):false"
                        @mouseleave="hideTooltip(event.id)"
                        @contextmenu.prevent="openContextMenu($event, event)"
                        :style="{minHeight : (selectedPeriod == 0) ? `${4*PlanningParams.minHeightDivDay}px` : `${PlanningParams.minHeightDivDay}px`,
                            backgroundColor : (event.fontcolor) ? event.fontcolor : '#FFFFFF',
                            borderColor : event.bordercolor
                        }"
                        >
                        <div class="planning-dot-state" :style="'background-color:'+event.dotcolor+';'"></div>
                        <CPage 
                        v-if="selectedPeriod == 0"
                        :pageTemplate="displayEncart(event)" 
                        :customparams="event.otherfields"
                        :page="page" 
                        :modal="modal"
                        :modalKey="modalKey" 
                        :form="false" 
                        hook="hook"
                        :mod="false"/>
                        <div v-else v-html="event.strdisplay"></div>
                        </div>
                        <!-- FIN RDV apres midi-->

                        <div class="planning-newhour" @click="createNewHourEvent(day,pers.line,'pm')"  v-if="!isMobile" >+pm</div>


                </div>

          


            </td>
            </tr>
            </template>
        </template>

        </tbody>
        </table>



    </div>

<tool/>
<cmenu/>

</div>
</template>

<script>


import mixins, {bus} from './mixins'
import { client } from '../mixins';  
import SimpleTable from "../../engine/outils/simpleTable.vue"
import { tooltipBus } from './tooltipBus'

import tool  from './tooltip.vue'
import cmenu  from './menu.vue'
    export default {

    name :'PlanningModule',

    mixins : [mixins, client],


    components : {
        SimpleTable,
        tool,
        cmenu
        },

        watch : {
            //c'est ici que commence le chargement des éléments du planning
        $route: {
        handler(to, from) {
            const newStart = to.query.start
            const oldStart = from.query.start

            if (newStart !== oldStart) {
            this.querys.start = newStart
            this.callAPI()
            }
        },
        deep: false
        },
            
            selectedPeriod(newPeriod) {
                    
                    this.$router.push({ query: {...this.$route.query, period: newPeriod } }).catch(() => {});
                    this.querys.period = newPeriod
                    this.callAPI()

            },

            callBackOnCloseModal: {
            // permet de rafraichir quand la modal de modif du module de la page se ferme
            handler(val) {

                if (val.show === false && Object.keys(this.fromThisMod).length !== 0) {
                this.specificRaf(this.fromThisMod)
                this.fromThisMod = {}
                }
            }, deep: true

            },
        },

        data: function() {

            return {

                show : false,
                AllowedDisplay : true,
                params:{},
                querys:{},

                listEvents : [],
                listGroup : [{name:'liste...',id:false,list:[{name:'ligne',line:false}]}],
                listFiches : [],
                tabsFiches : 'none',
                selectedFicheTabs : null,
                waitingElems :[{id:5,type:"pose","title":"evnew"},{id:6,type:"pose","title":"martin"}],

                ficheSelected : false,
                joursFerie : {},
                fichesForward : [],
                overlays : {},

                datePicker : this.$route.query.start,
                menu : [],
                menuPosition: { x: 0, y: 0 },
                fromThisMod : {},
                //permet d'afficher le progress linear lors de l'appel des listes
                waitCallList : false,
                firstLoad : true,
                isMobile : false,
                displayweekend : {},
                actionsOnClick : {},
                inspectionTable: '',
                lastTapAt: 0,
                dragging : false,
                tooltips : [],
                encarts : [],

                //pour la fonction reccurennce
                dialogReccur : false,
                //choix de l'utilisateur
                choiceReccur : '',
                //event selectionné
                eventReccur : {},
                //permet de savoir ce qu'il fait après le choix pour la recurrence
                typeActionReccur : '',
            }
        },

        computed : {
            callBackOnCloseModal() {
            return this.$store.getters.modalShowParams({ type: 'current', val: this.modalKey })
            },
            extraFixedColumns() {
                return this.isMobile ? 1 : 2;
            },

            filteredWeeks() {
                if (!this.weeks || !Array.isArray(this.weeks)) return [];
                return this.weeks
                    .map((week) => {
                        const days = Array.isArray(week.days) ? week.days : [];
                        const visibleDays = days.filter(day => {
                            const dayIndex = day.day() // 0 = dimanche, 6 = samedi

                            if (dayIndex === 6 && !this.displayweekend.sat) return false;
                            if (dayIndex === 0 && !this.displayweekend.sun) return false;
                            if (this.isMobile && this.isWeekend(day)) {
                                return false;
                            }
                            return true; // afficher tous les autres jours
                        });

                        return { ...week, visibleDays };
                    })
                    .filter(week => week.visibleDays.length);
            },

            visibleDays() {
                return this.filteredWeeks.reduce((acc, week) => acc.concat(week.visibleDays), []);
            },
            dayColumns() {
                return this.visibleDays.length;
            },
            groupColSpan() {
                return this.dayColumns + this.extraFixedColumns;
            },

            recurrForAll() {
            const ev = this.eventReccur;
            return (this.typeActionReccur !== 'drop' || (this.typeActionReccur == 'drop' && this.moment(ev.start).isSame(this.moment(ev.lineorigin.start), 'day')) );
            }
        },

        methods :  {


            handleDragChange(value) {
                this.dragging = value
            },
            handleReloadFromMenu(id) {
                this.specificRaf({getevent:id})
            },
            handleFromThisModule(id) {
                this.$set(this.fromThisMod, 'getevent', id)
            },
            handleDeleteEvent(id) {
                this.delEvent(id)
            },

            showTooltip(e, event) {
                if (this.dragging) return;
                const tooltipDef = this.tooltips.find(el => el.key === event.tooltip);
                    if (!tooltipDef) return;

                clearTimeout(this.tooltipHideTimeout);
                tooltipBus.$emit('show-tooltip', {
                tooltip: tooltipDef.construct,
                params: event.otherfields,
                id: event.id,
                x: e.clientX,
                y: e.clientY - 60,
                page : this.page,
                modal : this.modal,
                modalKey : this.modalKey 
                });

            },
            hideTooltip() {
                this.tooltipHideTimeout = setTimeout(() => {
                tooltipBus.$emit('hide-tooltip');
                }, 100);
            },

            openContextMenu(e, event) {
                tooltipBus.$emit('show-menu', {
                event: event,
                x: e.clientX,
                y: e.clientY,
                page : this.page,
                idmodule : this.idmodule,
                modalKey : this.modalKey,
                table: this.inspectionTable
                });
            },

            displayEncart(event) {
                return JSON.parse(JSON.stringify(this.encarts.find(el => el.key === event.encart)?.['construct']??[]))
            },


            onDbl(ev) {
                if (this.isMobile) {
                this.actEvent(ev);
                } else {
                this.pinEvent(ev);
                }
            },
            onTouchEnd(ev) {
                const now = Date.now();
                if (now - this.lastTapAt < 300) {   // second tap < 300ms => double-tap
                this.onDbl(ev);
                this.lastTapAt = 0;               // reset
                } else {
                this.lastTapAt = now;
                }
            },

            updateIsMobile() {
                if(typeof window === 'undefined') return;
                this.isMobile = window.innerWidth < 960;
            },

            callAPI : function() {
                //dans le watch il y a '$route.query.start' et "selectedPeriod", ces deux se lancent dès le chargement du planning.
                //car start se créé via mixins et period aussi..
                if(this.firstLoad) {
                    this.firstLoad = false
                    return;
                }
                    this.API({type:'post', url:'displaymodule', params:{id:this.idmodule,params:this.params,querys:this.querys}}).then((resp) => {
                        this.manageDatas(resp.data)
                            
                    })
    
                },  

                manageDatas(data) {
                    if(!data.success) {
                            this.AllowedDisplay = false; 
                            return false;
                            }
                            this.listGroup = data.lines.group
                            this.listEvents = []                     
                            this.listEvents = data.events
                            this.listFiches = data.listfiches
                            this.actionsOnClick = data.actiononclick
                            this.inspectionTable = data.table || ''
                            this.displayweekend = data.displayweekend
                            this.tooltips = data.tooltips
                            this.encarts = data.encarts
                            this.tabsFiches = ''
                            this.show = true 
                },

            //selectionne la fiche sur le click de la ligne
            putFicheForward(line) {
                //insertion dans la liste
                const exists = this.fichesForward.some(fiche => fiche.id === line.id);
                if (!exists) {
                this.fichesForward.push(line);
                }
                //select auto
                this.ficheSelected = line
                //retour au planning
                this.tabsFiches = null
            },

            removeForward(fiche,index) {
                const selected = this.fichesForward.some(list => fiche.id === list.id);
                if (selected) {
                    this.ficheSelected = false
                }
                this.fichesForward = this.fichesForward.filter((el,i) => i!=index)

            },

            callList(fiche,i) {
                
                //si l'onglet est deja ouvert et qu'on reclique dessus il se ferme :
                if(this.tabsFiches==fiche.key) this.tabsFiches = ''
                if(this.listFiches[i].list.length && !fiche.isdroppable) return;
                this.waitCallList = true;
                this.API({type:'post', url:'displaymodule', params:{id:this.idmodule,getlistkey:fiche.key,params:this.params,querys:this.querys}}).then((resp) => {

                    this.$set(this.listFiches,i,resp.data)
                    this.waitCallList = false;
                })                
            },

            resizeStart() {

            },

            onResize() {

            },

            onDropTab(event,tab) {

                this.API({type:'post', url:'displaymodule', params:{id:this.idmodule,action:'droptab',fiche:event.dataset.id,key:tab.dataset.key}}).then((resp) => {
                    if(resp.data.success) {
                        this.listEvents = this.listEvents.filter(el => el.id != event.dataset.id)
                        // on recharge la liste d'event dans l'onglet concerné :
                        this.listFiches.forEach((fiche,i) => {
                            if(fiche.key== tab.dataset.key) {
                                this.callList(fiche,i)
                                this.tabsFiches = fiche.key;
                            }
                        })
                    } else {
                        this.$toast.error(resp.data.message)
                    }
                    
                })
            },

            onDropCol(event,elements) {
                
                this.API({type:'post', url:'displaymodule', params:{id:this.idmodule,action:'droplist',fiche:event.dataset.id,start:elements.start,end:elements.end,line:elements.line,allday:elements.allday,key:event.dataset.list_key}}).then((resp) => {
                    if(resp.data.success) {
                        // on recharge la liste d'event dans l'onglet concerné :
                        this.listFiches.forEach((fiche,i) => {
                            if(fiche.key== event.dataset.list_key) {
                                
                                this.callList(fiche,i)
                                this.tabsFiches = fiche.key;
                            }
                        })
                        // on rajouter l'event dans le planning :
                        this.listEvents.push(resp.data.events[0])                        
                    } else {
                        this.$toast.error(resp.data.message)
                    }
                    
                }) 
            },

            resizeStop(el,passRecurr) {

                if(this.actionReccur(el, 'resize',passRecurr)) return;                

                this.API({type:'post', url:'displaymodule', params:{id:this.idmodule,action:'resize',event:el,recurrence:passRecurr}}).then((resp) => {
                        if(resp.data.events) {
                            //on supprime tous les events relatifs aux personnes
                            this.listEvents = this.listEvents.filter(item => item.id !== el.id);
                            this.listEvents = [...this.listEvents, ...resp.data.events]
                        }
                })

                
            },

            delEvent(el,passRecurr) {
                if(this.actionReccur(el, 'delete',passRecurr)) return;

                if(confirm('Vous allez supprimer ce RDV continuer ?')) {
                    this.API({type:'post', url:'displaymodule', params:{id:this.idmodule,action:'delete',event:el,recurrence:passRecurr}}).then((resp) => {
                            if(!resp.data.success) {
                                this.$toast.error(resp.data.message)
                                return
                                
                            }
                            this.listEvents = this.listEvents.filter(item => !(item.id === el.id && item.line === el.line));
                            if(resp.data.events) {
                                //on supprime tous les events relatifs aux personnes                           
                                this.listEvents = [...this.listEvents, ...resp.data.events]
                            }
                    })
                }

            },


            selectFiche(line) {
                this.ficheSelected = line
            },

            createNewDayEvent(elements) {
                //elements : {start:yyyy-mm-dd hh:mm:ss, end:yyyy-mm-dd hh:mm:ss, line:perosnne concerné}
                if(this.ficheSelected) {

                    if(confirm('Confirmer l\'insertion ?')) {
                        this.API({type:'post', url:'displaymodule', params:{id:this.idmodule,action:'insert',fiche:this.ficheSelected,start:elements.start,end:elements.end,line:elements.line,allday:true}}).then((resp) => {

                        if(resp.data.success) {
                            this.listEvents.push(resp.data.events[0])
                        } else {
                            this.$toast.error(resp.data.message)
                        }
                        })                 
                    }      
                    this.ficheSelected = false; 
                } 

            },

            createNewHourEvent(day,line,when) {

            let start = day.clone()
            let end = day.clone()
            if(when=='am') {
                start = start.clone().hour(this.PlanningParams.AMHourStart).minute(this.PlanningParams.AMMinStart).format('YYYY-MM-DD HH:mm:ss')
                end = end.clone().hour(this.PlanningParams.AMHourEnd).minute(this.PlanningParams.AMMinEnd).format('YYYY-MM-DD HH:mm:ss') 
            }
            if(when=='pm') {
                start = start.clone().hour(this.PlanningParams.PMHourStart).minute(this.PlanningParams.PMMinStart).format('YYYY-MM-DD HH:mm:ss')
                end = end.clone().hour(this.PlanningParams.PMHourEnd).minute(this.PlanningParams.PMMinEnd).format('YYYY-MM-DD HH:mm:ss') 
            }
                if(this.ficheSelected) {

                    this.$set(this.overlays,when+'-'+day.format('YYYY-MM-DD')+'-'+line,true);
                    this.API({type:'post', url:'displaymodule', params:{id:this.idmodule,action:'insert',fiche:this.ficheSelected,start:start,end:end,line:line,allday:false}}).then((resp) => {
                        this.$set(this.overlays,when+'-'+day.format('YYYY-MM-DD')+'-'+line,false);
                        if(resp.data.success) {
                            this.listEvents.push(resp.data.events[0])
                        } else {
                            this.$toast.error(resp.data.message)
                        }
                    })

                } else {
                //si aucune fiche et que le module permet l'ajout d'un event :
                    if(this.actionsOnClick.newevent) {
                            let params = {}
                            this.actionsOnClick.newevent.params.forEach((get)=> {
                                switch(get['value']) {
                                    case '[[start]]' :
                                    params[get['key']] = start
                                        break;
                                    case '[[end]]' :
                                    params[get['key']] = end
                                        break;
                                    case '[[allday]]' :
                                    params[get['key']] = 0
                                        break;
                                    case '[[line]]' :
                                    params[get['key']] = (this.actionsOnClick.newevent.islinepivot) ? [line] : line;
                                        break;
                                }

                            })
                        this.goTo({modalKey:this.modalKey,name:this.actionsOnClick.newevent.pagename,typeform:'new',type:'modal',replace:params,paramDialog:{width:1000}})
                        this.fromThisMod['getday'] = day.clone().format('YYYY-MM-DD');
                    } else {
                        this.$toast.warning('veuillez selectionner une fiche ')
                    }
                    
                }

            },
            

            onDropEvent(element,passRecurr) {
                //si il ne deplace pas :
                if(element.lineorigin.id == element.el.id 
                && element.lineorigin.line == element.el.line 
                && element.lineorigin.start == element.el.start
                && element.lineorigin.end == element.el.end) return;

                if(this.actionReccur(element, 'drop',passRecurr)) return;
                
                // on enleve l'event pour un petit moment
                this.listEvents = this.listEvents.filter(item => !(item.id === element.lineorigin.id && item.line === element.lineorigin.line))
                //on loade l'encart qui va accueillir le rdv
                this.overlays[element.demi+'-'+element.day+'-'+element.el.line] = true
                console.log('voila')
                this.API({type:'post', url:'displaymodule', params:{id:this.idmodule,action:'drop',event:element.el,origin:element.lineorigin,recurrence:passRecurr}}).then((resp) => {
                this.overlays[element.demi+'-'+element.day+'-'+element.el.line] = false
                    if(!resp.data.success) {
                        this.$toast.error(resp.data.message)
                        this.listEvents.push(element.lineorigin)
                    } else {
                            //si il faut rafraichir la colonne par rapport à des events issus de table pivot
                    //si il faut rafraichir la colonne par rapport à des events issus de table pivot
                        if(resp.data.events) {
                            //on supprime tous les events relatifs aux personnes
                            this.listEvents = this.listEvents.filter(item => item.id !== element.lineorigin.id);
                            this.listEvents = [...this.listEvents, ...resp.data.events]
                        } else {
                            this.listEvents.push(element.el)
                        }           
                    }
                })    
            },

            /*eslint-disable*/
            onClickButton: function (item, men) { 
            if(men.target=='modal') this.fromThisMod['getevent'] = item.id;    
            this.clickActions({args:item.otherfields,action:men,idmodule:this.idmodule,page:this.page,modalKey:this.modalKey,
            success:(datas) => {
                if(datas.message) this.$toast.success(datas.message);
                if(men.typelink == 'api') {
                    //rafraich de l'event
                    this.specificRaf({getevent:item.id})
                }
            }    
            })

            },

            specificRaf(elems) {
                this.API({type:'post', url:'displaymodule', params:{id:this.idmodule,rafraich:elems,params:this.params,querys:this.querys}}).then((resp) => {

                if(resp.data.success) {
                    for (const key in elems) {
                        if(key=='getevent') this.listEvents = this.listEvents.filter(el => el.id !== elems[key])
                        if(key=='getday') this.listEvents = this.listEvents.filter(el => el.start.split(' ')[0] !== elems[key])
                        if(key=='getline') this.listEvents = this.listEvents.filter(el => el.line !== elems[key])
                    }
                        this.listEvents = [...this.listEvents, ...resp.data.events];
                } else {
                    this.$toast.error(resp.data.message)
                }
                }) //fin API                
            },

            pinEvent(event) {
                var Ev = JSON.parse(JSON.stringify(event))
                Ev.ongletname = event.otherfields.ongletname
                Ev.ongletcolor = event.otherfields.ongletcolor
                this.putFicheForward(Ev)
            },

            //lors du click de l'event
            actEvent(event) {
                if(this.isMobile && this.actionsOnClick.divonmobile!='') {

                    if(this.actionsOnClick.divonmobile) {
                        if(this.actionsOnClick.divonmobile.target=='modal') this.fromThisMod['getevent'] = event.id;    
                        this.clickActions({args:event.otherfields,action:this.actionsOnClick.divonmobile,idmodule:this.idmodule,page:this.page,modalKey:this.modalKey,
                        success:(datas) => {
                            if(datas.message) this.$toast.success(datas.message);
                        }    
                        })
                    }                    
                }
            },

            actLine(pers) {
                if(this.actionsOnClick.linename!='') { 
                    if(this.actionsOnClick.linename.target=='modal') this.fromThisMod['getline'] = pers.id;
                    this.clickActions({args:pers,action:this.actionsOnClick.linename,idmodule:this.idmodule,page:this.page,modalKey:this.modalKey,
                    success:(datas) => {
                        if(datas.message) this.$toast.success(datas.message);
                    }    
                    })
                }
            },

            cancelReccur() {
                    this.choiceReccur = '';
                    this.eventReccur = {};
                    this.typeActionReccur = '';
                    this.dialogReccur = false;

            },




            applyChangeReccur() {
                switch(this.typeActionReccur) {
                    case 'drop' :

                        this.onDropEvent(this.eventReccur,this.choiceReccur) 
                    break;
                    case 'resize' :

                        this.resizeStop(this.eventReccur,this.choiceReccur) 
                    break;
                    case 'delete' :

                        this.delEvent(this.eventReccur,this.choiceReccur)
                    break;
                }
            this.cancelReccur()
            },

            actionReccur(el,type,passRecurr) {
                //si il envoi une recurrence d'une personne à un autre, on ne fait rien, ca udate normalement
                let initialEventID = (type=='drop') ? el.el.initialEventID : el.initialEventID
                if(type=='drop' && el.el.line != el.lineorigin.line) return false;
                if(initialEventID && !passRecurr) {
                    this.typeActionReccur = type
                    this.eventReccur = el;
                    this.dialogReccur = true;
                    return true;
                }
                return false;
            },


            /*
            updateStickyHeaderOffsets() {
                this.$nextTick(() => {
                    const wrapper = this.$refs.planningScroll;
                    if (!wrapper) return;

                    const rows = wrapper.querySelectorAll(".planning-table thead tr");
                    if (!rows.length) {
                        return;
                    }

                    let cumulative = 0;
                    const offsets = [];
                    rows.forEach((row, index) => {
                        if (index > 0) {
                            offsets[index] = cumulative;
                        }
                        cumulative += row.offsetHeight;
                    });

                    const offset1 = offsets[1] || 0;
                    const offset2 = offsets[2] || offsets[1] || 0;

                    const cache = this._stickyHeaderOffsets || {};
                    if (cache.first !== offset1) {
                        wrapper.style.setProperty("--planning-header-offset-1", `${offset1}px`);
                    }
                    if (cache.second !== offset2) {
                        wrapper.style.setProperty("--planning-header-offset-2", `${offset2}px`);
                    }
                    this._stickyHeaderOffsets = { first: offset1, second: offset2 };
                });
            }, */
        },

        mounted() {
            this.updateIsMobile();
            //this.updateStickyHeaderOffsets();
            bus.$on('drag:change', this.handleDragChange)
            tooltipBus.$on('reloadfrommenu', this.handleReloadFromMenu)
            tooltipBus.$on('fromthismod', this.handleFromThisModule)
            tooltipBus.$on('delEvent', this.handleDeleteEvent)

            if(typeof window !== 'undefined') {
                window.addEventListener('resize', this.updateIsMobile);
                //window.addEventListener('resize', this.updateStickyHeaderOffsets);
            }
        },

        updated() {
            //this.updateStickyHeaderOffsets();
            //bus.$on('drag:change', (v) => this.dragging = v)
            
        },

        beforeDestroy() {
            bus.$off('drag:change', this.handleDragChange)
            tooltipBus.$off('reloadfrommenu', this.handleReloadFromMenu)
            tooltipBus.$off('fromthismod', this.handleFromThisModule)
            tooltipBus.$off('delEvent', this.handleDeleteEvent)
            clearTimeout(this.tooltipHideTimeout)
            if(typeof window !== 'undefined') {
                window.removeEventListener('resize', this.updateIsMobile);
                //window.removeEventListener('resize', this.updateStickyHeaderOffsets);
            }
        },

        created() {
            this.show = true;
            this.params = this.$store.getters.specificPage(this.modalKey).params    
            this.querys = JSON.parse(JSON.stringify(this.$route.query));

            if(this.$route.query.start && this.$route.query.period) {
                this.firstLoad = false
                this.callAPI()
            }
            

            //récupération des jours feries 
                fetch("https://date.nager.at/api/v3/PublicHolidays/"+new Date().getFullYear()+"/fr")
                .then(response => response.json())
                .then(data => {
                const obj = {}
                data.forEach(item => {
                    obj[item.date] = item.localName || item.name
                })
                this.joursFerie = obj
                    // data est un objet avec des dates comme clés : { "2025-01-01": "Jour de l'An", ... }
                })
                .catch(error => {
                    console.error('Erreur lors de la récupération des jours fériés:', error);
                });
        }

    }

</script>


<style scoped>

.planning-table {
    border:1px solid;
    border-collapse:collapse;
    width:100%;
    position: relative;
}
.planning-table th {
    font-size:13px;
    font-weight:normal;
    border:1px solid grey;
    padding:2px;
    background-color: #fff;
}
.planning-table thead th {
    position: sticky;
    top: 0;
    z-index: 3;
}
.planning-table thead tr:nth-child(2) th {
    top: var(--planning-header-offset-1, 0px);
    z-index: 2;
}
.planning-table thead tr:nth-child(3) th {
    top: var(--planning-header-offset-2, 0px);
    z-index: 1;
}


.planning-container {
  overflow-x: auto; /* Permet le défilement horizontal */
  white-space: nowrap; /* Empêche le contenu de se casser en plusieurs lignes */
  padding:10px;
}
.planning-scroll-wrapper {
  max-height: 80vh;
  overflow-y: auto;
  overflow-x: visible;
}

.planning-table tbody td {
    position: relative;  /* Permet au contenu absolu de se positionner relativement à chaque td */
    vertical-align: top; /* Assure que le contenu reste aligné en haut */
    padding: 0; /* Supprime tout espace interne */
    margin: 0;
    height: 0px; /* Définissez une hauteur si nécessaire pour vos td */
    min-height:20px;
    border : 1px solid grey;

}


.planning-divday-content {
    position: absolute; /* Permet un positionnement précis */
    box-sizing: border-box; /* Inclut padding et border dans width/height */
    border: 1px solid grey;
    border-radius: 3px;
    margin: 1px; /* Ajoute un espace interne */
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 2px 3px 4px rgba(0, 0, 0, 0.5);
    z-index:2;
    overflow: hidden; /* Masque tout ce qui dépasse */
    white-space: nowrap; /* Empêche le texte de se diviser en plusieurs lignes */
}
.planning-divday-content > div {
    left:1px;
    top:0px;
    position:absolute;
    width:100%;
}
.planning-divhour-content > div {
    left:1px;
    top:0px;
    position:absolute;
    width:100%;
}
/*permet de ne pas sauter les lignes dans les div enfants */
.planning-divday-content .v-card,.planning-divhour-content .v-card   {
    white-space: nowrap !important;
}
.planning-container .v-data-table td, .v-data-table th {
    height:15px !important;
}
:deep().v-data-table td {
    height:15px !important;
}

/* le div qui affiche les event à l'horaire */
.planning-divhour-content {
    position:relative;
    border: 1px solid grey;
    border-radius: 3px;
    margin: 1px; /* Ajoute un espace interne */
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden; 
    white-space: nowrap; 
    font-size:12px;
}
/* div créé dynamiquement dans mixins.js : affiche un div fantome du nouvel event journee */
:deep().planning-divday-content-new {
    position: absolute; /* Permet un positionnement précis */
    box-sizing: border-box; /* Inclut padding et border dans width/height */
    border: 1px solid grey;
    border-radius: 3px;
    margin: 1px; /* Ajoute un espace interne */
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 5px 5px 6px rgba(0, 0, 0, 0.3);
    overflow: hidden; /* Masque tout ce qui dépasse */
    white-space: nowrap; /* Empêche le texte de se diviser en plusieurs lignes */
    opacity:0.5;
    background-color: #005dc7;
    z-index:1000;
}

.planning-table .planning-dot-state {
    position:absolute;
    top:0;
    left:0;
    border-radius:2px;
    height:7px;
    width:7px;
    border:1px solid grey;
}

.droppable-td.allday {
    background-color:aliceblue;
}
.droppable-td.allday.drop-activated,.drop-activated {
    background-color:rgb(177, 206, 238);
}

.planning-newhour {
    font-size:11px;
    border: 1px solid rgb(228, 228, 228);
    opacity:0.3;
    min-height:30px;
    display: flex;
    justify-content: center;
    align-items: center;
    height:100%;
    box-sizing: border-box;
}
.planning-newhour:hover {
    opacity:0.8;
    cursor:pointer;
    
}

.pl-design {
    text-align:center;
    vertical-align: middle !important;
    width:2px;
}


.hour-separator {
    border-color:black
}
.trhours:nth-child(even) {
  background-color: #eeeeee; /* Vert clair */
}

.namegroup {
    text-align:center;
}
.personnel-header {
    text-align:center;
    min-width: 48px;
}
.personnel-header span {
    display:block;
}
.namepers {
    text-align:center;
    font-weight:600;
}

.weekend {
    background-color: #F6D8CE !important;
}
.ferie {
    background-color: #d7ffe0 !important;
}
.iscoldraggable,.isdivresizable {
    user-select: none; /* Désactive la sélection */
}


</style>
